import { useContext } from "react";
import { StoreContext } from "../stores/rootStore";
import { observer } from "mobx-react-lite";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute: React.FC<{ children: React.ReactNode }> = observer(
  ({ children }) => {
    const rs = useContext(StoreContext);
    const location = useLocation();
    const isLoggedIn = rs.googleAuthStore.isLoggedIn;
    if (isLoggedIn) {
      return <>{children}</>;
    }
    return (
      <Navigate
        to="/login"
        replace={true}
        state={{ from: `${location.pathname}` }}
      />
    );
  },
);

export default PrivateRoute;
